// ErrorBoundary.tsx
import React from "react";

import ErrorFallback from "./ui/error-fallback";

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
  errorInfo?: React.ErrorInfo;
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren, ErrorBoundaryState> {
  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  constructor(props: React.PropsWithChildren) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Log the stack trace
    this.setState({ errorInfo });
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.hasError) {
      return (
        <ErrorFallback
          error={{
            // eslint-disable-next-line react/destructuring-assignment
            name: this.state.error?.name || "Error",
            // eslint-disable-next-line react/destructuring-assignment
            message: this.state.error?.message || "An error occurred",
            // eslint-disable-next-line react/destructuring-assignment
            stack: this.state.errorInfo?.componentStack ?? "",
          }}
        />
      );
    }
    // eslint-disable-next-line react/destructuring-assignment
    return this.props.children;
  }
}
